import { z } from "zod";

export const createWarehouseSchema = z.object({
  codebookFiles: z.array(z.string()).optional(),
  width: z.string(),
  height: z.string(),
  thickness: z.string().optional(),
  price: z.string(),
  quantity: z.string(),
  location: z.array(z.string()),
});

export type CreateWarehouse = z.infer<typeof createWarehouseSchema>;
